import { Api } from '@sodamnfoolish/spl-factory-backend-types';
import { Manager } from 'socket.io-client';

export const createSessionGatewayClient = (url: string, apiKey: string, session: string) =>
    new Manager(url, {
        extraHeaders: {
            'x-api-key': apiKey,
        },
        query: {
            sessionId: session,
        },
    })
        .socket('/session/gateway')
        .onAnyOutgoing((event: string) => console.debug(`Automatization gateway outgoing`, event));

export const logServerLog = (
    serverLog: Api.Session.Gateway.ServerLog,
    logMessage: ((message: string, type: 'success' | 'warn' | 'error' | undefined) => void) | undefined = undefined,
) => {
    const message = (serverLog.clientId ? `[${serverLog.clientId}] ` : '') + serverLog.message;

    if (logMessage)
        logMessage(
            message,
            serverLog.level == Api.Common.Gateway.LogLevel.Warn ? 'warn' : serverLog.level == Api.Common.Gateway.LogLevel.Error ? 'error' : undefined,
        );
    (serverLog.level == Api.Common.Gateway.LogLevel.Warn ? console.warn : serverLog.level == Api.Common.Gateway.LogLevel.Error ? console.error : console.log)(
        message,
    );
};
